
  <div>
    <div>
      <div>
        <div class="content" class="sidebar-container-content flex justify-center">
          <div style="width: 100%;" class="flex flex-col w-4on5 md-w-full">
            <h2>{{ 'app.changePassword.title'|translate }}</h2>
            <form [formGroup]="form" (ngSubmit)="onSave()">
              <mat-card appearance="outlined">
                <mat-card-content class="flex flex-col gap-6">
                  <mat-form-field class="flex-1">
                    <mat-label>{{ 'app.changePassword.currentPassword'|translate }}</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" required autocomplete="current-password"
                           formControlName="currentPassword" />
                    <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hide">
                      <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                  </mat-form-field>

                  <mat-form-field class="flex-1">
                    <mat-label>{{ 'app.changePassword.newPassword'|translate }}</mat-label>
                    <input matInput [type]="hideNewPassword ? 'password' : 'text'" required autocomplete="current-password"
                           formControlName="newPassword" />
                    <button type="button" mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hideNewPassword">
                      <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                  </mat-form-field>

                  <mat-form-field class="flex-1">
                    <mat-label>{{ 'app.changePassword.confirmPassword'|translate }}</mat-label>
                    <input matInput [type]="hideNewPassword2 ? 'password' : 'text'" required autocomplete="current-password"
                           formControlName="newPassword2" />
                    <button type="button" mat-icon-button matSuffix (click)="hideNewPassword2 = !hideNewPassword2" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="hideNewPassword2">
                      <mat-icon>{{ hideNewPassword2 ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                  </mat-form-field>

                </mat-card-content>

              </mat-card>

              <mat-dialog-actions>
                <div class="flex flex-row justify-right items-end">
                  <button mat-flat-button type="submit"
                          color="accent">{{ 'app.changePassword.saveButton' |translate }}
                  </button>
                </div>
              </mat-dialog-actions>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

<mic-alert-center [hideDelay]="8"></mic-alert-center>
